import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Config } from '@/config';
import {
  errorModalTextRecoil,
  completeModalRecoil,
  deviceAddModalRecoil,
  deviceCommandAddModalRecoil,
} from '@/atom/ModalAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import ModalType1 from '@/modal/ModalType1';
import { DeviceApi } from '@/sdk/DeviceApi';
import { deviceDetailRecoil } from '@/atom/DeviceAtom';
import { CreateDeviceCommandDtoTx } from '@/sdk/data-contracts';

const DeviceCommandAddModal = () => {
  const { id } = useParams<{ id: string }>();
  const deviceApi = new DeviceApi({ baseURL: Config.API_URL });
  const navigate = useNavigate();

  const setErrorModalText = useSetRecoilState(errorModalTextRecoil);
  const setCompleteModalState = useSetRecoilState(completeModalRecoil);
  const setDeviceAddModalState = useSetRecoilState(deviceAddModalRecoil);
  const setDeviceCommandAddModalState = useSetRecoilState(
    deviceCommandAddModalRecoil,
  );
  const [deviceDetailState, setDeviceDetailState] =
    useRecoilState(deviceDetailRecoil);

  const [repeatTime, setRepeatTime] = useState<string>('');
  const [content, setContent] = useState<string>('');
  const [description, setDescription] = useState<string>('');

  const handleSubmit = async () => {
    if (repeatTime === '' || content === '' || description === '') {
      setErrorModalText('빈 칸을 확인해 주세요.');
      return;
    }

    const dto: CreateDeviceCommandDtoTx = {
      repeatTime: Number(repeatTime),
      content,
      description,
    };

    try {
      await deviceApi.deviceControllerCreateCommand(Number(id), dto, {
        headers: {
          Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
          'Content-Type': 'application/json',
        },
      });
      setCompleteModalState(true);
    } catch (err: any) {}
  };

  return (
    <>
      <ModalType1 width={1000}>
        <div className="title-box flex aic jcsb">
          <h1>디바이스 명령어 전송</h1>
          <button
            className="x-btn img-box"
            onClick={() => setDeviceCommandAddModalState(false)}
          >
            <img src="/img/ico_x_444.svg" alt="" />
          </button>
        </div>
        <div className="cnt-area flex fdc">
          <div className="cnt-wrap flex fdc">
            <div className="cnt-box flex fdc">
              <div className="cnt-title-box flex jcsb aie">
                <div className="left-box">
                  <h2 className="tm">대상 디바이스 정보</h2>
                </div>
                <div className="right-box flex">
                  <h3>
                    <span className="inblock">*</span>필수 항목
                  </h3>
                </div>
              </div>
              <CS.TableType2>
                <table>
                  <tbody>
                    <tr>
                      <th>모델</th>
                      <td>{deviceDetailState?.modelName}</td>
                      <th>디바이스명</th>
                      <td>{deviceDetailState?.name}</td>
                    </tr>
                    <tr>
                      <th>디바이스 No</th>
                      <td>{deviceDetailState?.number}</td>
                      <th>Dev EUI</th>
                      <td>{deviceDetailState?.devEui}</td>
                    </tr>
                    <tr>
                      <th>통신상태</th>
                      <td>{deviceDetailState?.communicationStatus}</td>
                      <th>센서 상태</th>
                      <td>{deviceDetailState?.sensorStatus}</td>
                    </tr>
                    <tr>
                      <th>
                        반복 전송<span className="star-point">*</span>
                      </th>
                      <td colSpan={3}>
                        <div className="td-box">
                          <IS.TextInputType1
                            style={{ width: 100 }}
                            type="text"
                            value={repeatTime}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^\d*$/.test(value)) {
                                setRepeatTime(value);
                              }
                            }}
                          />
                          분
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        전송 내용<span className="star-point">*</span>
                      </th>
                      <td colSpan={3}>
                        <div className="td-box">
                          <IS.TextInputType1
                            style={{ width: 480 }}
                            type="text"
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                          />
                          <BS.Btn3Type3
                            type="button"
                            // onClick={() => setAddressModalState(true)}
                          >
                            즉시 전송
                          </BS.Btn3Type3>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        설명<span className="star-point">*</span>
                      </th>
                      <td colSpan={3}>
                        <IS.TextInputType1
                          style={{ width: 579 }}
                          type="text"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CS.TableType2>
            </div>
          </div>
          <div className="btn-wrap">
            <BS.Btn2Type3
              type="button"
              onClick={() => setDeviceCommandAddModalState(false)}
            >
              취소
            </BS.Btn2Type3>
            <BS.Btn2Type4 type="button" onClick={handleSubmit}>
              등록
            </BS.Btn2Type4>
          </div>
        </div>
      </ModalType1>
    </>
  );
};

export default DeviceCommandAddModal;
